import React from 'react'
import { HeadingProps, Heading as ChakraHeading } from '@chakra-ui/react'

function Heading(props: HeadingProps) {
  return (
    <ChakraHeading {...props} />
  )
}

export default Heading